import { PlantDto } from '@trucktrax/trucktrax-ts-common';

import { INVALID_STALE_TOKEN_LOGOUT } from '../constants/appConstants';
import { ERROR_TEXT_FETCH_PLANT_LIST } from '../constants/errorConstants';
import HTTP_CODES from '../constants/httpConstants';
import { getPlantList } from '../services/plantsService';

/** `devErrorAndLog` as the screens receive it — already bound to dispatch by connect. */
export type ReportPlantListError = (
  modalHeaderType: string,
  modalBodyLocation: any,
  errorObj?: any,
  extraInfo?: string,
  consoleOnly?: boolean,
) => void;

/**
 * The shared refetch policy for screens that keep their own plant list in component state
 * (DriverDetailView, DriversAddModal, TrucksAddModal, TrucksDetailView, OrdersView).
 *
 * getPlantList propagates since DEV-4427, so a failed refetch after a region or
 * product-line change would leave the previous selection's plants selectable — every one
 * of these screens clears instead.
 *
 * @returns the plants on success; `[]` on a reported failure (clear the picker);
 * `undefined` on the INVALID_STALE_TOKEN_LOGOUT signal, where the app is logging out and
 * the caller should leave its state untouched.
 */
export async function loadPlantListOrClear(
  region: string | undefined,
  productLine: string | undefined,
  context: string,
  report: ReportPlantListError,
): Promise<PlantDto[] | undefined> {
  try {
    return await getPlantList(region, productLine);
  } catch (e: any) {
    if (e === INVALID_STALE_TOKEN_LOGOUT) {
      return undefined;
    }
    const consoleOnly = e.response?.status === HTTP_CODES.forbidden;
    report(
      ERROR_TEXT_FETCH_PLANT_LIST,
      `${context} ${e.toString()}`,
      undefined,
      undefined,
      consoleOnly,
    );
    return [];
  }
}
